<template>
  <div class="" testek="product-detail">
    <div class="header"></div>
    <BaseDetail
      @viewDetail="viewDetail"
      @addData="addData"
      @addMoreData="addMoreData"
      :currentItem="currentItem"
      :titleDetail="$t('i18nCommon.TitleSaleEmployeeId')"
    >
      <template #header>
        <div class="font-bold text-xl mb-4">
          {{ title }}
        </div>
      </template>
      <template #content>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="ruleForm"
              :rules="rules"
              label-width="120px"
              class="demo-ruleForm"
              :size="formSize"
              status-icon
            >
              <a-form-item
                prop="Id"
                testek="Id"
                class="columns-1 w-full"
                v-if="mode == $enum.Mode.Edit"
                labelAlign="left"
              >
                <div class="flex">
                  <div class="font-bold min-w-32">ID</div>
                  <a-input v-model:value="ruleForm.id" />
                </div>
              </a-form-item>
              <div class="flex columns-2">
                <a-form-item prop="fullName" testek="name" class="w-full mr-8">
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Name") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.fullName" />
                  </div>
                </a-form-item>
                <a-form-item prop="phoneNumber" testek="phoneNum" class="w-full">
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Phone") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.phoneNumber" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="email" testek="email" class="w-full mr-8">
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      Email
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.email" />
                  </div>
                </a-form-item>
                <a-form-item prop="userStatus" testek="userStatus" class="w-full">
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Status") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <h-combobox
                      :data="statuses"
                      :display="'status'"
                      :keyValue="'id'"
                      @change="onChangeStatus"
                      :placeholder="$t('i18nProduct.Status')"
                      :value="ruleForm.userStatus"
                      testek="status-combobox"
                    ></h-combobox>
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-2">
                <a-form-item prop="group" testek="group" class="w-full mr-8">
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Department") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.group" />
                  </div>
                </a-form-item>
                <a-form-item prop="dob" testek="dob" class="w-full">
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.DateOfBirth") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.dob" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="note" testek="note" class="w-full">
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Note") }}
                      <span class="ml-1 text-red-700">*</span>
                    </div>
                    <a-input v-model:value="ruleForm.note" />
                  </div>
                </a-form-item>
              </div>
              <!-- <div class="flex columns-1">
                <a-form-item
                  prop="avatar"
                  testek="avatar"
                  class="w-full"
                  labelAlign="left"
                >
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Avatar") }}
                    </div>
                    <a-upload
                      :file-list="fileList"
                      :remove="handleRemove"
                      :before-upload="beforeUpload"
                    >
                      <a-button>
                        <upload-outlined></upload-outlined>
                        Click to Upload
                      </a-button>
                    </a-upload>
                  </div>
                </a-form-item>
              </div> -->
              <a-form-item class="mt-6">
                <div class="flex">
                  <a-button
                    type="primary"
                    testek="btn-add"
                    @click="submitForm()"
                    class="mr-4"
                  >
                    {{ $t("i18nCommon.Add") }}
                  </a-button>
                  <a-button type="primary" testek="btn-add-more" @click="addMoreData()">
                    {{ $t("i18nCommon.AddMore") }}
                  </a-button>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </template>
    </BaseDetail>
    <div v-if="isShow && employee">
      <a-modal v-model:open="isShow" centered :width="800" :closable="false">
        <div class="header-detail flex justify-between mb-6">
          <div class="font-bold text-2xl">
            {{ $t("i18nCommon.TitleDetailInfo") }}
          </div>
          <div
            class="text-white h-9 w-36 bg-slate-900 rounded-lg flex justify-center items-center"
          >
            {{ $t("i18nCommon.SaleEmployee") }}
          </div>
        </div>
        <div class="content">
          <div class="product-detail-form">
            <a-form
              ref="ruleFormRef"
              :model="ruleForm"
              :rules="rules"
              label-width="120px"
              class="demo-ruleForm"
              :size="formSize"
              status-icon
            >
              <div class="flex">
                <div class="flex-1">
                  <div class="flex columns-1">
                    <a-form-item prop="fullName" testek="name" class="w-full">
                      <div class="flex items-center">
                        <div class="flex min-w-32 font-bold">
                          {{ $t("i18nProduct.Name") }}
                        </div>
                        <a-input v-model:value="employee.empFullName" :disabled="true" />
                      </div>
                    </a-form-item>
                  </div>
                  <div class="flex columns-1">
                    <a-form-item prop="phoneNumber" testek="phoneNum" class="w-full">
                      <div class="flex items-center">
                        <div class="flex min-w-32 font-bold">
                          {{ $t("i18nProduct.Phone") }}
                        </div>
                        <a-input v-model:value="employee.phoneNumber" :disabled="true" />
                      </div>
                    </a-form-item>
                  </div>
                  <div class="flex columns-1">
                    <a-form-item prop="email" testek="email" class="w-full">
                      <div class="flex items-center">
                        <div class="flex min-w-32 font-bold">Email</div>
                        <a-input v-model:value="employee.email" :disabled="true" />
                      </div>
                    </a-form-item>
                  </div>
                  <div class="flex columns-1">
                    <a-form-item prop="status" testek="status" class="w-full">
                      <div class="flex items-center">
                        <div class="flex min-w-32 font-bold">
                          {{ $t("i18nProduct.Status") }}
                        </div>
                        <a-input v-model:value="employee.status" :disabled="true" />
                      </div>
                    </a-form-item>
                  </div>
                </div>
                <div class="flex flex-1 justify-center items-center">
                  <div class="logo-employee-default h-64 w-64"></div>
                </div>
              </div>
              <div class="flex columns-2 mt-6">
                <a-form-item prop="department" testek="department" class="w-full mr-8">
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Department") }}
                    </div>
                    <a-input v-model:value="employee.group" :disabled="true" />
                  </div>
                </a-form-item>
                <a-form-item prop="dateOfBirth" testek="DateOfBirth" class="w-full">
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.DateOfBirth") }}
                    </div>
                    <a-input v-model:value="employee.empDoB" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
              <div class="flex columns-1">
                <a-form-item prop="note" testek="note" class="w-full">
                  <div class="flex items-center">
                    <div class="flex min-w-32 font-bold">
                      {{ $t("i18nProduct.Note") }}
                    </div>
                    <a-input v-model:value="employee.notes" :disabled="true" />
                  </div>
                </a-form-item>
              </div>
            </a-form>
          </div>
        </div>
        <template #footer>
          <a-button key="back" @click="isShow = false">{{
            $t("i18nCommon.Close")
          }}</a-button>
        </template>
      </a-modal>
    </div>
  </div>
</template>

<script>
import BaseDetail from "@/views/base/BaseDetail.vue";
import { mapActions } from "vuex";
import { ModuleEmployee } from "@/store/module-const";
export default {
  name: "SaleEmployeeDetail",
  components: {
    BaseDetail,
  },
  props: {},
  data() {
    return {
      ruleForm: {},
      rules: {},
      contacts: [],
      statuses: [],
      currentItem: {},
      employee: {},
      isShow: false,
      mode: this.$enum.Mode.Add,
    };
  },
  computed: {
    title() {
      if (this.mode == this.$enum.Mode.Edit) return this.$t("i18nCommon.EditEmployee");
      return this.$t("i18nCommon.AddEmployee");
    },
  },
  created() {
    const me = this;
    me.initDataStatic();
    me.$emitter.on("LoadEditEmployee", me.loadDataEdit);
  },
  beforeDestroy() {
    const me = this;
    me.$emitter.off("LoadEditEmployee", me.loadDataEdit);
  },
  methods: {
    ...mapActions(ModuleEmployee, ["getEmployee", "createEmployee", "updateEmployee"]),
    initDataStatic() {
      const me = this;
      me.rules = {
        fullName: [
          {
            required: true,
            message: `${me.$t("i18nProduct.NameInvalid")}`,
            trigger: "blur",
          },
        ],
        phoneNumber: [
          {
            required: true,
            message: `${me.$t("i18nProduct.PhoneNumberInvalid")}`,
            trigger: "blur",
          },
        ],
        empCode: [
          {
            required: true,
            message: `${me.$t("i18nProduct.CodeInvalid")}`,
            trigger: "blur",
          },
        ],
        dob: [
          {
            required: true,
            message: `${me.$t("i18nProduct.DateOfBirthInvalid")}`,
            trigger: "blur",
          },
        ],
        note: [
          {
            required: true,
            message: `${me.$t("i18nProduct.NoteInvalid")}`,
            trigger: "blur",
          },
        ],
        userStatus: [
          {
            required: true,
            message: `${me.$t("i18nProduct.StatusInvalid")}`,
            trigger: ["change", "blur"],
          },
        ],
        group: [
          {
            required: true,
            message: `${me.$t("i18nProduct.GroupInvalid")}`,
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: `${me.$t("i18nProduct.EmailInvalid")}`,
            trigger: "blur",
          },
        ],
      };
      me.statuses = this.$config.StatusInfos;
    },
    loadDataEdit: _.debounce(async function (payload) {
      const me = this;
      if (!payload) return;
      me.mode = payload.mode;
      setTimeout(async () => {
        let employee = await me.getEmployee({ id: payload.id });
        if (employee) {
          me.ruleForm = {
            id: employee.id,
            fullName: employee.empFullName,
            phoneNumber: employee.phoneNumber,
            empCode: employee.empCode,
            dob: employee.empDoB,
            empAvatar: employee.empAvatar,
            note: employee.notes,
            userStatus: employee.status,
            group: employee.group,
            email: employee.email,
          };
        }
      }, 300);
    }, 300),
    async submitForm(isReset = true) {
      const me = this;
      let formEl = me.$refs.ruleFormRef;
      if (!formEl) return;

      formEl
        .validate()
        .then(async () => {
          if (me.mode == me.$enum.Mode.Edit) {
            await me.editData();
          } else {
            await me.addData(isReset);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    onChangeStatus(payload) {
      const me = this;
      let status = me.statuses.find((x) => x.id == payload);
      if (status) {
        me.ruleForm.userStatus = status.id;
      }
    },
    addMoreData: _.debounce(async function () {
      const me = this;
      await me.submitForm(false);
    }, 300),

    addData: _.debounce(async function (isReset = true) {
      const me = this;
      let result = await me.createEmployee(me.ruleForm);
      if (result && result.data) {
        me.currentItem = result.data;
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.AddEmployeeSuccess")
        );
        if (isReset == true) {
          me.ruleForm = {};
        }
        // me.$router.push("/product");
      } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(result.message, "warning");
      } else {
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.AddEmployeeFail"),
          "warning"
        );
      }
    }, 300),

    editData: _.debounce(async function () {
      const me = this;
      let result = await me.updateEmployee(me.ruleForm);
      if (result && result.data) {
        me.currentItem = result.data;
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.EditEmployeeSuccess")
        );
        me.ruleForm = {};
      } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
        me.currentItem.messageResponse = JSON.stringify(result);
        this.$messageNotification.messageNotification(result.message, "warning");
      } else {
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.EditEmployeeFail"),
          "warning"
        );
      }
    }, 300),

    viewDetail: _.debounce(async function (params) {
      const me = this;
      if (!params || !params.id) return;

      //lấy dữ liệu chi tiết từ API
      me.employee = await me.getEmployee({ id: params.id });
      if (me.employee) {
        me.isShow = true;
      } else {
      }
      //Show form chi tiết
    }, 300),

    beforeUpload(file) {
      const me = this;
      me.fileList = [file];
      return false;
    },
    handleRemove(file) {
      const me = this;
      const index = me.fileList.indexOf(file);
      const newFileList = me.fileList.slice();
      newFileList.splice(index, 1);
      me.fileList = newFileList;
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  background: initial !important;
  color: initial !important;
}
</style>
